import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

type propsType = {
    title: string,
    desc: string,
    img: string,
    goto: string
}

const CardBtn = (props: propsType) => {
    const navigate = useNavigate()

    return (
        <Container onClick={() => navigate(props.goto)} title={props.title}>
            <TextWrapper>
                <div className='title'>{props.title}</div>
                <div className='desc'>{props.desc}</div>
            </TextWrapper>
            <Img src={props.img}/>
        </Container>

    )
};

export default CardBtn

const Container = styled.div`
    width: 300px;
    height: 80px;
    border: none;
    border-radius: 20px;

    background-color: #101e5d;
    color: #fff;
    padding: 20px 20px 10px 20px;

    display: flex;
    justify-content: space-between;
    gap: 20px;

    &:hover {
        background-color: ${'var(--custom-purple-1)'}
    }
`

const TextWrapper = styled.div`
    flex-direction: column;

    .title { 
        font-size: 20px;
    }

    .desc {
        margin-top: 5px;
        font-size: 9px;
        color: #DEDFE4;
    }
`

const Img = styled.img`
    widht: 60px;
    height: 60px;
    position: relative;
    right: 0;
    filter: invert(1);
`